import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'vue-toast-notification/dist/theme-sugar.css'

import AccountAnchorImage from './components/image/AccountAnchorImage.vue'
import AccountFollowers from './components/AccountFollowers.vue'
import AccountImage from './components/image/AccountImage.vue'
import AccountInfoMobile from './components/header/mobile/AccountInfo.vue'
import AccountInfoPC from './components/header/pc/AccountInfo.vue'
import AccountLogin from './components/header/AccountLogin.vue'
import CircleAnchorImage from './components/image/CircleAnchorImage.vue'
import CircleFollowers from './components/CircleFollowers.vue'
import CircleImage from './components/image/CircleImage.vue'
import CommentEdit from './components/CommentEdit.vue'
import Entry from './components/Entry.vue'
import EntryEdit from './components/entry-edit.vue'
import EmojiDialog from './components/EmojiDialog.vue'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import FilterDialog from './components/entry/FilterDialog.vue'
import Footer from './components/footer/FooterIndex.vue'
import FooterNavigation from './components/footer/FooterNavigation.vue'
import Header from './components/Header.vue'
import HeaderLogo from './components/header/HeaderLogo.vue'
import HeaderNavigation from './components/header/HeaderNavigation.vue'
import KeywordSearchDialog from './views/keyword-search/keyword-search-dialog.vue'
import LogoutAnchor from './components/header/LogoutAnchor.vue'
import { Mentionable } from 'vue-mention'
import NewHashtag from './components/NewHashtag.vue'
import NotificationsTooltip from './components/header/NotificationsTooltip.vue'
import SideMenu from './components/SideMenu.vue'
import TemporarySignIn from './views/registration/TemporarySignIn.vue'
import Tweet from '@/components/entry/Tweet.vue'
import ValidationErros from './components/ValidationErrors.vue'
import VueObserveVisibility  from 'vue3-observe-visibility'
/* font awesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
/* font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(far, fas)

createApp(App)
.use(FloatingVue)
.use(store)
.use(router)
.use(VueObserveVisibility)
.component('c-account-anchor-image', AccountAnchorImage)
.component('c-account-followers', AccountFollowers)
.component('c-account-image', AccountImage)
.component('c-account-info-mobile', AccountInfoMobile)
.component('c-account-info-pc', AccountInfoPC)
.component('c-account-login', AccountLogin)
.component('c-circle-anchor-image', CircleAnchorImage)
.component('c-circle-followers', CircleFollowers)
.component('c-circle-image', CircleImage)
.component('c-comment-edit', CommentEdit)
.component('c-entry', Entry)
.component('c-entry-edit', EntryEdit)
.component('c-emoji-dialog', EmojiDialog)
.component('c-filter-dialog', FilterDialog)
.component('c-footer', Footer)
.component('c-footer-navigation', FooterNavigation)
.component('c-header', Header)
.component('c-header-logo', HeaderLogo)
.component('c-header-navigation', HeaderNavigation)
.component('font-awesome-icon', FontAwesomeIcon)
.component('c-keyword-search-dialog', KeywordSearchDialog)
.component('c-logout-anchor', LogoutAnchor)
.component('c-new-hashtag', NewHashtag)
.component('c-notifications-tooltip', NotificationsTooltip)
.component('c-side-menu', SideMenu)
.component('c-temporary-sign-in', TemporarySignIn)
.component('c-tweet', Tweet)
.component('c-validation-errors', ValidationErros)
.component('mentionable', Mentionable)
.mount('#app')
